import { useLazyLoadQuery } from 'react-relay';
import { getGuidedTourContent } from '../../graphQLOperations/Skills';
import {
  SkillsGuidedTourContentQuery,
  SkillsGuidedTourContentQuery$data,
} from '../../graphQLOperations/__generated__/SkillsGuidedTourContentQuery.graphql';
import { SkillAncestriesId } from '../../models/SkillAncestries';
import { SupportSkills } from '../../models/SupportSkills';
import { adaptSupportSkillsFromSearch } from './guidedTour';
import { removeHighlight } from '../../utils/removeSearchHighlight';

export interface GuidedTourContent {
  skill: SkillsGuidedTourContentQuery$data['siteSpecificSkillInfoBySkillCode'] | null;
  videoUrl: string | null;
  captionUrlEnglish: string | null;
  captionUrlSpanish: string | null;
  highSupportSkills: SupportSkills[];
  midSupportSkills: SupportSkills[];
}

export function useGuidedTourContent(skillCode: string): GuidedTourContent {
  const data = useLazyLoadQuery<SkillsGuidedTourContentQuery>(getGuidedTourContent, {
    skillCode,
    urlsFilter: { storedObjectType: 'WORKED_EXAMPLE_VIDEO' },
    ancestriesIds: [SkillAncestriesId.MEDIUM, SkillAncestriesId.HIGH],
  });

  const skillNode =
    data.searchSkills?.nodes?.find(node => node?.code && removeHighlight(node.code) === skillCode) ?? null;
  const { highSupportSkills, midSupportSkills } = adaptSupportSkillsFromSearch(skillNode);

  return {
    skill: data.siteSpecificSkillInfoBySkillCode ?? null,
    videoUrl: data.presignedURLsForSkill?.workedExampleVideoUrl ?? null,
    captionUrlEnglish: data.presignedURLsForSkill?.workedExampleVideoEnglishCaptionUrl ?? null,
    captionUrlSpanish: data.presignedURLsForSkill?.workedExampleVideoSpanishCaptionUrl ?? null,
    highSupportSkills,
    midSupportSkills,
  };
}
